import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ManualAwardsService } from 'src/app/gamification/command-center/services/manual-awards.service';
import { GamificationMainService } from 'src/app/gamification/command-center/services/gamification-main.service';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'cv-coins-earned',
    templateUrl: './coins-earned.component.html',
    styleUrls: ['./coins-earned.component.scss']
})
export class CoinsEarnedComponent implements OnInit, OnChanges, OnDestroy {
    @Input() coins: any;
    @ViewChild('coinsEarnedGrid') agGrid: AgGridAngular;

    mas = null;
    gms = null;
    isDestroyed = false;
    coinsTable: GridOptions;
    localization = new Map();

    constructor(
        private cvNumberLocalizePipe: CvNumberLocalizePipe,
        private manualAwardsService: ManualAwardsService,
        private gamificationMainService: GamificationMainService,
        private cvLocalizationService: CVLocalizationService,
    ) {
        this.mas = this.manualAwardsService.data;
        this.gms = this.gamificationMainService.data;
        $(document).on('event_SelectedGroupsChanged', this.onGroupsChangedHandler);
    }

    ngOnInit(): void {
        this.loadLocalization();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.coins) {
            if (this.agGrid && this.agGrid?.api) {
                this.agGrid?.api.setGridOption('rowData', changes.coins.currentValue);
            }
        }
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    loadLocalization(): void {
        this.cvLocalizationService.GetSection("Gamification_Admin").then((map) => {
            this.localization = map;
            this.setupGrid();
        });
    }

    setupGrid(): void {
        this.coinsTable = {
            accentedSort: true,
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true
            },

            columnDefs: [{
                field: 'Login',
                headerName: this.getColumnName('Name_Column', 'Name'),
                lockVisible: true,
                cellRenderer: (params) => {
                    var cellElement = '<div class="d-flex align-items-center h-100"><img class="rounded-circle mr-2" src="..' + params.data.Login.ProfileImageUri + '&w=64&h=64" style="width: 32px;">';
                    cellElement += '<span>' + params.data.Login.PreferredName + '</span></div>';

                    return cellElement;
                },
                valueGetter: (params) => {
                    return params.data.Login.PreferredName;
                },
            }, {
                field: 'CoinsEarned',
                headerName: this.getColumnName('Coin_Earnings', 'Coin Earnings'),
                type: 'numericColumn',
                cellRenderer: (params) => '<div class="d-flex align-items-center h-100 justify-content-end">' + this.cvNumberLocalizePipe.transform(params.value) + '</div>'
            }],
            rowData: this.gms.usersCoinsEarned,
            rowHeight: 64,
            suppressDragLeaveHidesColumns: true,
            overlayLoadingTemplate: '<div class="loadView mt-5"></div>',

            getRowId: ({ data: rowData }) => {
                return rowData.Login.LoginID;
            },

            onGridReady: (e: GridReadyEvent) => {
                this.loadData();
                e.api.sizeColumnsToFit();
            },

            onFirstDataRendered: (e) => {
                e.columnApi.applyColumnState({ state: [{ "colId": "CoinsEarned", "sort": "desc" }] });
                e.api.sizeColumnsToFit();
            },
        };
    }

    loadData(): void {
        if (this.agGrid && this.agGrid?.api) {
            this.agGrid?.api.showLoadingOverlay();
        }

        this.gamificationMainService.loadUserCoinEarnings().then(() => {
            if (this.agGrid && this.agGrid?.api) {
                this.agGrid?.api.setGridOption('rowData', this.gms.usersCoinsEarned);
                this.agGrid?.api.hideOverlay();
            }
        });
    }

    getColumnName(key: string, defaultValue: string): string {
        if (this.localization && this.localization.has(key)) {
            return this.localization.get(key);
        }
        else { return defaultValue; }
    }

    onGroupsChanged(e: any): void {
        if (this.isDestroyed) {
            return;
        }

        this.loadData();
    }

    private onGroupsChangedHandler = (e: any) => this.onGroupsChanged(e);
}
